import qs from "qs";
import axios from "axios";
import { URL, API_URL } from "../../../constants/Constants";

/**
 * Establece un log
 * @param {string} query_type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} Log - Log (mantenido por compatibilidad, no se usa)
 * @param {string} tipoLog - Tipo de log
 * @param {string} data - Datos
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const setLog = async (query_type, Log, tipoLog, data) => {
  const userData = {
    screen: "log",
    action: "create_log",
    tipoLog: tipoLog,
    info: data,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(userData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.error(
        "Error en la respuesta del servidor:",
        response.data.message
      );
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
